import { useEffect } from "react";
import { useStockStore } from "../store";

export const useStockResetStore = () => {
  const reset = useStockStore((s) => s.reset);

  useEffect(() => {
    return () => {
      reset();
    };
  }, []);
};
